<template>
  <div>
    <v-dialog v-model="dialogOpen" persistent max-width="1000">
      <v-card>
        <v-card-title>Contracts</v-card-title>

        <v-card-text>
          <v-data-table :headers="headers" :items="getContracts" disable-sort :loading="getIsContractsLoading" :server-items-length="getPaginationConfigs.paginationCount" :page="getPaginationConfigs.page" :options.sync="options" :footer-props="{ itemsPerPageOptions }">
              <template v-slot:item.creation_timestamp="{ item }">
                <span>{{ item.creation_timestamp | formatDate }}</span>
              </template>

              <template v-slot:item.reason="{ item }">
                <span>{{ getReason(item.reason) | capitalizeString | customPlaceholder }}</span>
              </template>

              <template v-slot:item.download="{ item }">
                <div class="d-flex">
                  <div v-if="item.contract_summaries_sent" class="mr-2">
                    <v-btn x-small color="secondary" :loading="getIsDownloadContractLoading('summary', item.id)" @click="downloadContract({ type: 'summary', id: item.id })">summary</v-btn>
                  </div>

                  <div v-if="item.contract_summaries_sent" class="mr-2">
                    <v-btn x-small color="secondary" :loading="getIsDownloadContractLoading('information', item.id)" @click="downloadContract({ type: 'information', id: item.id })">information</v-btn>
                  </div>

                  <div v-if="item.contract_sent">
                    <v-btn x-small color="secondary" :loading="getIsDownloadContractLoading('contract', item.id)" @click="downloadContract({ type: 'contract', id: item.id })">contract</v-btn>
                  </div>
                </div>
              </template>
            </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" small outlined class="ml-3" @click="close">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from "vuex";

  export default {
    props: ["dialogOpen", "product_id"],

    data() {
      return {
        headers: [
          { text: 'Created', value: 'creation_timestamp' },
          { text: 'User', value: 'user' },
          { text: 'Reason', value: 'reason' },
          { text: 'Status', value: 'status' },
          { text: 'Downloads', value: 'download' },
        ],
        options: {
          itemsPerPage: 25,
          page: 1,
        },
        itemsPerPageOptions: [5,10,15,25,50],
      }
    },

    watch: {
      watchOpenAndOptions: {
        immediate: false,
        deep: true,
        handler(val) {
          const [a, b] = val.split('|');
          if(JSON.parse(a) && JSON.parse(b)) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(() => {
              this.fetchContracts({ id: this.product_id, options: this.options });
            }, 200);
          }
        }
      }
    },

    computed: { 
      ...mapGetters("products/contracts", ["getContracts", "getIsContractsLoading", "getPaginationConfigs", "getIsDownloadContractLoading"]),

      getReason() {
        return (reason) => {
          if(!reason) return reason;
          const [val1, val2] = reason.split("_");
          if(val1 && val2) return `${val1} ${val2}`;
          return val1;
        }
      },

      watchOpenAndOptions() {
        return `${this.dialogOpen}|${JSON.stringify(this.options)}`;
      },
    },

    methods: {
      ...mapActions("products/contracts", ["downloadContract", "fetchContracts"]),
      ...mapMutations("products/contracts", ["RESET_CONTRACT_STORE"]),

      close() {
        this.RESET_CONTRACT_STORE();
        this.$emit('close-dialog');
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
